// components/FallbackPlaylist/index.js

import FallbackPlaylist from './FallbackPlaylist';

export default FallbackPlaylist;
